(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-lg-topbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeTopbars() {
    document.querySelectorAll('[data-sb-leadgen-topbar]').forEach(function (root) {
      if (root.dataset.sbScrollInitialized === 'true') return;
      root.dataset.sbScrollInitialized = 'true';
      var animationFrame = null;

      root.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 ||
            event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!(event.target instanceof Element)) return;

        var link = event.target.closest('[data-sb-logo-link], [data-vip-link]');
        if (!link || !root.contains(link)) return;

        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#' || href.length < 2) return;

        var targetId;
        try {
          targetId = decodeURIComponent(href.substring(1));
        } catch (error) {
          return;
        }

        var target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);

        var startY = window.scrollY;
        var targetY = Math.max(0, target.getBoundingClientRect().top + startY - 80);
        var distance = targetY - startY;
        var startTime = null;

        function finishScroll() {
          if (target.hasAttribute('tabindex') ||
              target.matches('a[href], button, input, select, textarea')) {
            target.focus({ preventScroll: true });
          }
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.scrollTo({ top: targetY, behavior: 'instant' });
          finishScroll();
          return;
        }

        function animateScroll(timestamp) {
          if (!root.isConnected || !target.isConnected) return;
          if (startTime === null) startTime = timestamp;

          var progress = Math.min((timestamp - startTime) / 900, 1);
          var easedProgress = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          window.scrollTo({
            top: startY + distance * easedProgress,
            behavior: 'instant'
          });

          if (progress < 1) {
            animationFrame = window.requestAnimationFrame(animateScroll);
          } else {
            animationFrame = null;
            finishScroll();
          }
        }

        animationFrame = window.requestAnimationFrame(animateScroll);
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTopbars);
  } else {
    initializeTopbars();
  }

  document.addEventListener('shopify:section:load', initializeTopbars);
})();

  } catch(e) { console.error(e); }
})();
})();
